import React, { useState, useEffect } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown, faUser, faAdd, faList, faUniversity, faSchool, faArrowRight, faBuildingColumns, faEllipsisVertical, faSearch, faXmark, faBell, faMaximize, faGear, faInbox, faTasks, faSlidersH, faSignIn, faChevronRight, faHome } from "@fortawesome/free-solid-svg-icons";

import "./StudentProfile.css";

import { Scissors } from "lucide-react";
import axios from "axios";

const StudentProfile = () => {
    const navigate = useNavigate();
    const [isSidebarExpanded, setSidebarExpanded] = useState(true);
    const [activeDropdown, setActiveDropdown] = useState(null);  
    const [showoption, setShowoption] = useState(false);
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const [isSearchVisible, setSearchVisible] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchIconVisible, setSearchIconVisible] = useState(true);
    const [customizersetting, setcustomizersetting] = useState(false);
    const [enterexam,setEnterexam]=useState(false)
    const [enterpraticeexam,setEnterpraticeexam]=useState(false)
    const [studentid,setstudentid]=useState('')
    const [showschedule ,setShowschedule ]= useState(false)
    const [popup, setPopup] = useState(false);
    const [examtypeid, setExamtypeid]=useState(null)
    // const [appalayids,setAppalayids]=useState(null)

    const handlecustomizer = () => {
      setcustomizersetting(!customizersetting);
    };
  
    const handleInputChange = (e) => {
      setSearchQuery(e.target.value);
    };
  
    const toggleSearchForm = () => {
      setSearchVisible(!isSearchVisible);
      setSearchIconVisible(!isSearchIconVisible); // Toggle visibility of the search icon
    };
  
  
    const toggleSidebar = () => {
      setSidebarExpanded(!isSidebarExpanded);
    };
  
    const toggleDropdown = (dropdown) => {
      setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
    };
    const handleshow = () => {
      setShowoption(!showoption);
    };
    const handlelogout = () => {
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("isInstitutionLogin");
      localStorage.removeItem("isStudentLogin");
  
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("username");
      localStorage.removeItem("userRole");
      localStorage.removeItem("referralid");
      navigate("/");
      window.location.reload(); // Reload to update the UI after logout
    };
  
    useEffect(() => {
      const handleResize = () => {
        if (window.innerWidth < 992) {
          setSidebarExpanded(false);
        }
      };
  
      window.addEventListener("resize", handleResize);
      handleResize();
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    const user = localStorage.getItem("userRole");




    const handleSubmit = async () => {
  if (!studentid.trim()) {
    alert("Please enter a Student ID");
    return;
  }
navigate('/exampage', { state: { studentid ,examtypeid} });

};
    const handleSubmit_praticeexam = async () => {
  if (!studentid.trim()) {
    alert("Please enter a Student ID");
    return;
  }
 navigate('/praticeexam', { state: { studentid } });
  // console.log("Submitting Student ID:", studentid);

 
};

 const [schedule, setSchedule] = useState([]);
  const [appalayids, setAppalayids] = useState([]);

  // ✅ Get applied exam type IDs
  const appalyexam = async () => {
    const userid = localStorage.getItem('UserId');
    try {
      const response = await axios.get(`${process.env.REACT_APP_API}/auth/checkappalay/${userid}`);
      const examTypeIds = response.data.appalay.map(item => Number(item.exam_types)); // Ensure it's numbers
      setAppalayids(examTypeIds);
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Get current active exams
  const getexamtype = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API}/questions/getexamtype`);
      const today = new Date();
      const filtered = res.data.data.filter(
        (exam) => new Date(exam.to_date) >= today
      );
      setSchedule(filtered);
    } catch (error) {
      console.log(error);
    }
  };

  // ✅ Run both on mount
  useEffect(() => {
    appalyexam();
    getexamtype();
  }, []);


  const handleNavigate=()=>{
    setShowschedule(false)
    setPopup(true)
  }


  return (
    <div>
    <div className="page-wrapper compact-wrapper" id="pageWrapper">
      <div
        className="page-main-header"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="main-header-right">
          <div className="main-header-left">
            <div className="logo-wrapper">
              {/* <NavLink to='/'><img src="./assets/logo.png" alt="Logo" style={{ height: '50px' }} /></<NavLink> */}
              <NavLink to="/">
                <img
                  src="./assets/logo.png"
                  alt="Logo"
                  style={{ height: "50px" }}
                />{" "}
              </NavLink>
            </div>
          </div>
          <div className="mobile-sidebar">
            <div className="flex-grow-1 text-end switch-sm">
              <label className="switch">
                <input
                  id="sidebar-toggle"
                  type="checkbox"
                  onChange={toggleSidebar}
                  checked={isSidebarExpanded}
                />
                <span className="switch-state"></span>
              </label>
            </div>
          </div>
          <div className="nav-right col pull-right right-menu">
            <ul className="nav-menus">
              {/* <li className="px-0">
    <form className={`form-inline search-form ${isSearchVisible ? 'd-block' : 'd-none'}`}>
      <input
        type="text"
        className="form-control-plaintext"
        placeholder="Search....."
        value={searchQuery}
        onChange={handleInputChange}
        aria-label="Search input"
      />
      <FontAwesomeIcon
        icon={faXmark}
        className="close-search"
        onClick={toggleSearchForm}
        aria-label="Close search"
      />
    </form>
    <span
      className="mobile-search"
      onClick={toggleSearchForm}
      aria-label="Open search form"
    >
      <FontAwesomeIcon icon={faSearch} />
    </span>
  </li> */}

              <li className="px-0">
                {/* Search form */}
                <form
                  className={`form-inline search-form ${
                    isSearchVisible ? "d-block" : "d-none"
                  }`}
                >
                  <input
                    type="text"
                    className="form-control-plaintext"
                    placeholder="Search....."
                    value={searchQuery}
                    onChange={handleInputChange}
                    aria-label="Search input"
                  />
                  <FontAwesomeIcon
                    icon={faXmark}
                    className="close-search"
                    onClick={toggleSearchForm} // Clicking cancel hides the search form
                    aria-label="Close search"
                  />
                </form>

                {/* Mobile search icon */}
                {isSearchIconVisible && (
                  <span
                    className="mobile-search"
                    onClick={toggleSearchForm} // Clicking the search icon shows the form
                    aria-label="Open search form"
                  >
                    <FontAwesomeIcon icon={faSearch} />
                  </span>
                )}
              </li>
              <li className="onhover-dropdown">
                <FontAwesomeIcon icon={faBell} />
                <ul className="notification-dropdown onhover-show-div">
                  <li className="d-block">
                    <h6 className="f-w-600">Notifications</h6>
                    <span className="f-12">You have 0 unread messages</span>
                  </li>
                  <li className="bg-light txt-dark">
                    <a>All notifications</a>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  className="text-dark"
                  href="#!"
                  onClick={() => document.documentElement.requestFullscreen()}
                >
                  <FontAwesomeIcon icon={faMaximize} />
                </a>
              </li>
              <li className="theme-setting" onClick={handlecustomizer}>
                <FontAwesomeIcon icon={faGear} />
              </li>
              <li className="onhover-dropdown px-0">
                <span className="d-flex user-header">
                  <img
                    className="me-2 rounded-circle img-35"
                    src="user.png"
                    alt="User"
                  />
                  <span className="flex-grow-1">
                    <span className="f-12 f-w-600">
                      {localStorage.getItem("userRole")}
                    </span>
                    <span className="d-block">
                      {localStorage.getItem("username")}
                    </span>
                  </span>
                </span>
                <ul className="profile-dropdown onhover-show-div">
                  <li>
                    <FontAwesomeIcon icon={faUser} /> Profile
                  </li>
                  <NavLink to="/">
                    <li className="f-w-600">
                      <FontAwesomeIcon icon={faHome} /> Home
                    </li>
                  </NavLink>
                  <li className="f-12">
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faInbox} className="ms-2" /> Inbox
                  </li>
                  <li className="f-12">
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faTasks} className="ms-2" />{" "}
                    Taskboard
                  </li>
                  <li className="f-12">
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon
                      icon={faSlidersH}
                      className="ms-2"
                    />{" "}
                    Settings
                  </li>
                  <li onClick={handlelogout}>
                    <FontAwesomeIcon icon={faSignIn} /> Log out
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div
            className="d-lg-none mobile-toggle pull-right"
            onClick={handleshow}
          >
            <FontAwesomeIcon icon={faEllipsisVertical} size="lg" />
          </div>
        </div>
        {showoption && (
          <div className="mobile-nav-right">
            <ul className="nav-menus">
              <li className="px-0">
                <form className="form-inline search-form">
                  <input
                    className="form-control-plaintext"
                    placeholder="Search....."
                  />
                  <FontAwesomeIcon icon={faXmark} className="close-search" />
                </form>
                <span className="mobile-search">
                  <FontAwesomeIcon icon={faSearch} />
                </span>
              </li>
              <li className="onhover-dropdown">
                <FontAwesomeIcon icon={faBell} />
                <ul className="notification-dropdown onhover-show-div">
                  <li className="d-block">
                    <h6 className="f-w-600">Notifications</h6>
                    <span className="f-12">You have 2 unread messages</span>
                  </li>
                  <li className="bg-light txt-dark">
                    <a href="#">All notifications</a>
                  </li>
                </ul>
              </li>
              <li>
                <a
                  className="text-dark"
                  href="#!"
                  onClick={() => document.documentElement.requestFullscreen()}
                >
                  <FontAwesomeIcon icon={faMaximize} />
                </a>
              </li>
              <li className="theme-setting">
                <FontAwesomeIcon icon={faGear} />
              </li>
              <li className="onhover-dropdown px-0">
                <span className="d-flex user-header">
                  <img
                    className="me-2 rounded-circle img-35"
                    src="user.png"
                    alt="User"
                  />
                  <span className="flex-grow-1">
                    <span className="f-12 f-w-600">
                      {localStorage.getItem("userRole")}
                    </span>
                    <span className="d-block">
                      {localStorage.getItem("username")}
                    </span>
                  </span>
                </span>
                <ul
                  className="profile-dropdown onhover-show-div"
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <li>
                    <FontAwesomeIcon icon={faUser} /> Profile
                  </li>
                  <NavLink to="/">
                    <li className="f-w-600">
                      <FontAwesomeIcon icon={faHome} /> Home
                    </li>
                  </NavLink>
                  <li className="f-12">
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faInbox} className="ms-2" /> Inbox
                  </li>
                  <li className="f-12">
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon icon={faTasks} className="ms-2" />{" "}
                    Taskboard
                  </li>
                  <li className="f-12">
                    <FontAwesomeIcon icon={faChevronRight} />
                    <FontAwesomeIcon
                      icon={faSlidersH}
                      className="ms-2"
                    />{" "}
                    Settings
                  </li>
                  <li onClick={handlelogout}>
                    <FontAwesomeIcon icon={faSignIn} /> Log out
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        )}
      </div>

      <div className="page-body-wrapper sidebar-icon">
        <header
          className="main-nav"
          style={{
            width: isSidebarExpanded ? "250px" : "70px",
            transition: "width 0.3s ease-in-out",
            height: "100vh",
          }}
        >
          <nav>
            <div className="main-navbar">
              <div className="left-arrow" id="left-arrow">
                <i data-feather="arrow-left"></i>
              </div>
              <div id="mainnav" className="sidepage">
                {isSidebarExpanded ? (
                  <ul>
                    {localStorage.getItem("userRole") === "supperadmin" ? (
                      <li>
                        <h6
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                          onClick={() => toggleDropdown("admin")}
                        >
                          Admin
                          <FontAwesomeIcon
                            icon={faCaretDown}
                            rotation={activeDropdown === "admin" ? 0 : 270} // Rotate the icon when dropdown is open
                          />
                        </h6>
                        {/* Dropdown for Admin */}
                        {activeDropdown === "admin" && (
                          <ul className="admin_dropdown">
                            <li>
                              <Link to="/adminadd">
                                <h6>Admin Add</h6>
                              </Link>
                            </li>
                            <li>
                              <Link to="/adminform">
                                <h6>Admin Form</h6>
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    ) : (
                      <></>
                    )}

                    {(localStorage.getItem("userRole") === "supperadmin" ||
                      localStorage.getItem("userRole") === "admin") && (
                      <li>
                        <h6
                          style={{
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            paddingRight: "10px",
                          }}
                          onClick={() => toggleDropdown("institution")}
                        >
                          Institution
                          <FontAwesomeIcon
                            icon={faCaretDown}
                            rotation={
                              activeDropdown === "institution" ? 0 : 270
                            } // Rotate the icon when dropdown is open
                          />
                        </h6>
                        {/* Dropdown for Institution */}
                        {activeDropdown === "institution" && (
                          <ul className="admin_dropdown">
                            <li>
                              <Link to="/institutionform">
                                <h6>Institution Add</h6>
                              </Link>
                            </li>
                            <li>
                              <Link to="/institution">
                                <h6>Institution Form</h6>
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    )}

                    <li>
                      <h6
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                        onClick={() => toggleDropdown("students")}
                      >
                        Students
                        <FontAwesomeIcon
                          icon={faCaretDown}
                          rotation={activeDropdown === "students" ? 0 : 270} // Rotate the icon when dropdown is open
                        />
                      </h6>
                      {/* Dropdown for Students */}
                      {activeDropdown === "students" && (
                        <ul className="admin_dropdown">
                          <li>
                            <a href="#">
                              <h6>Student Add</h6>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <h6>Student Form</h6>
                            </a>
                          </li>
                        </ul>
                      )}
                    </li>

                    <li>
                      <h6
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          paddingRight: "10px",
                        }}
                        onClick={() => toggleDropdown("exam")}
                      >
                        Exam Portal
                        <FontAwesomeIcon
                          icon={faCaretDown}
                          rotation={activeDropdown === "exam" ? 0 : 270} // Rotate the icon when dropdown is open
                        />
                      </h6>
                      {/* Dropdown for Students */}
                      {activeDropdown === "exam" && (
                        <ul className="admin_dropdown">
                          {/* <li>
                            <a href="#">
                              
                              <NavLink to="/studentexam"><h6>May 2025 Application Enter</h6></NavLink>
                            </a>
                          </li> */}
                          <li>
                            <a href="#">
                              <h6>Applied Exams</h6>
                            </a>
                          </li>
                          <li>
                            <a href="#">
                              <h6>Exam Marks</h6>
                            </a>
                          </li>
                        </ul>
                      )}
                    </li>

                  
                  </ul>
                ) : (
                  // Small Navigation when the sidepage is hidden
                  <ul className="small-nav-icons">
                    {localStorage.getItem("userRole") === "supperadmin" ? (
                      <li>
                        <NavLink>
                          <FontAwesomeIcon
                            icon={faUser}
                            className="nav-icon"
                            onClick={() => toggleDropdown("admin")}
                          />
                        </NavLink>

                        {activeDropdown === "admin" && (
                          <ul className="admin_dropdownicon">
                            <li>
                              <Link to="/adminadd">
                                <FontAwesomeIcon
                                  icon={faUser}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />
                                <FontAwesomeIcon
                                  icon={faAdd}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to="/adminform">
                                <FontAwesomeIcon
                                  icon={faUser}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />
                                <FontAwesomeIcon
                                  icon={faList}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    ) : (
                      <></>
                    )}

                    {(localStorage.getItem("userRole") === "supperadmin" ||
                      localStorage.getItem("userRole") === "admin") && (
                      <li>
                        <NavLink>
                          <FontAwesomeIcon
                            icon={faUniversity}
                            className="nav-icon"
                            onClick={() => toggleDropdown("institution")}
                          />
                        </NavLink>
                        {activeDropdown === "institution" && (
                          <ul className="admin_dropdownicon">
                            <li>
                              <Link to="/institution">
                                <FontAwesomeIcon
                                  icon={faUniversity}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />
                                <FontAwesomeIcon
                                  icon={faAdd}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                            <li>
                              <Link to="/institutionform">
                                <FontAwesomeIcon
                                  icon={faUniversity}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />
                                <FontAwesomeIcon
                                  icon={faList}
                                  className="nav-icon"
                                  style={{ fontSize: "19px" }}
                                />{" "}
                              </Link>
                            </li>
                          </ul>
                        )}
                      </li>
                    )}

                    <li>
                      <NavLink>
                        <FontAwesomeIcon
                          icon={faSchool}
                          className="nav-icon"
                          onClick={() => toggleDropdown("students")}
                        />
                      </NavLink>
                      {activeDropdown === "students" && (
                        <ul className="admin_dropdownicon">
                          <li>
                            <Link to="/studentform">
                              <FontAwesomeIcon
                                icon={faSchool}
                                className="nav-icon"
                                style={{ fontSize: "19px" }}
                              />
                              <FontAwesomeIcon
                                icon={faAdd}
                                className="nav-icon"
                                style={{ fontSize: "19px" }}
                              />{" "}
                            </Link>
                          </li>
                          <li>
                            <Link to="/studentadd">
                              <FontAwesomeIcon
                                icon={faSchool}
                                className="nav-icon"
                                style={{ fontSize: "19px" }}
                              />
                              <FontAwesomeIcon
                                icon={faList}
                                className="nav-icon"
                                style={{ fontSize: "19px" }}
                              />{" "}
                            </Link>
                          </li>
                        </ul>
                      )}
                    </li>
                   
                  </ul>
                )}
              </div>
              <div className="right-arrow" id="right-arrow">
                <i data-feather="arrow-right"></i>
              </div>
            </div>
          </nav>
        </header>









        <div
          className="page-body"
          style={{
            marginLeft: isSidebarExpanded ? "250px" : "70px",
            transition: "margin-left 0.3s ease-out",
          }}
        >
          {/* Content goes here */}

          <div className="container-fluid">
            <div className="row" style={{ paddingTop: "20px" }}>
             


            

            


<div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-secondary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faBuildingColumns} />
                          </div>
                          <div className="flex-grow-1">
                            <h4 style={{ color: "white" }}>Apply exam</h4>
                            <Link to="/studentexam">
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            <FontAwesomeIcon
                              icon={faBuildingColumns}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>





                  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-secondary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faBuildingColumns} />
                          </div>
                          <div className="flex-grow-1">
                            <h4 style={{ color: "white" }}>Exam id</h4>
                            <Link to='/studentid'>
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                            <FontAwesomeIcon
                              icon={faBuildingColumns}
                              className="icon-bg"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  



               <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-secondary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faBuildingColumns} />
                          </div>
                          <div className="flex-grow-1">
                            <h4 style={{ color: "white" }}>Exam </h4>
                            <Link
                            //  onClick={()=>setEnterexam(true)}
                            // onClick={() => setPopup(true)}
                                onClick={()=>setShowschedule(true)}
                             >
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 


  <div className="col-sm-6 col-xl-3 col-lg-6">
                    <div className="card o-hidden">
                      <div className="bg-secondary b-r-4 card-body">
                        <div className="d-flex static-top-widget">
                          <div className="align-self-center text-center">
                            <FontAwesomeIcon icon={faBuildingColumns} />
                          </div>
                          <div className="flex-grow-1">
                            <h4 style={{ color: "white" }}>Exam Result</h4>
                            <Link
                            to={'/examresult'}
                            //  onClick={()=>setEnterexam(true)}
                            // onClick={() => setPopup(true)}
                             >
                              <h6
                                style={{ color: "white" }}
                                className="mb-0 counter"
                              >
                                more info{" "}
                                <FontAwesomeIcon
                                  icon={faArrowRight}
                                  style={{ color: "#ffffff" }}
                                />
                              </h6>
                            </Link>
                           
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> 


{popup && (
  <div className="exam-popup-overlay" style={{ position: 'fixed' }}>
    <div className="exam-popup-box">
      <button className="exam-popup-close" onClick={() => setPopup(false)}>×</button>

      <div style={{ maxHeight: "500px" }}>
        <div className="popup">
          <h5>Would you like to go to the exam registration page?</h5>
          <div style={{ marginTop: '20px' }}>
            <button onClick={() => {
              setPopup(false);
              navigate('/studentexam');
            }}>
              Yes
            </button>
            <button onClick={() => setPopup(false)} style={{ marginLeft: '10px' }}>
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}


                
{/* 
{showschedule && schedule && Array.isArray(schedule) && (
  <div className="exam-popup-overlay" style={{ position: "fixed" }}>
    <div className="exam-popup-box">
      <button
        className="exam-popup-close"
        onClick={() => setShowschedule(false)}
      >
        ×
      </button>
      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
        <ul className="exam-schedule-list">
          {[
            ...schedule.filter((value) => appalayids.includes(value.id)), // Applied first
            ...schedule.filter((value) => !appalayids.includes(value.id)) // Not applied after
          ].map((value, index) => {
            const isApplied = appalayids.includes(value.id);
            const isHovered = hoveredIndex === index;

            return (
              <li
                key={index}
                className="exam-schedule-item"
                style={{
                  cursor: "pointer",
                  color: isApplied
                    ? isHovered ? "#333" : "black"
                    : isHovered ? "#b30000" : "red",
                  backgroundColor: isApplied
                    ? isHovered ? "#e0e0e0" : "#f0f0f0"
                    : isHovered ? "#ffcccc" : "#ffe5e5"
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
               onClick={() => {
                      if (!isApplied) {
                      // navigate('/studentexam');
                      
                      handleNavigate()
                      } else {
                        setExamtypeid(value.id)
                      setEnterexam(true);
                      }
                      }}

              >
                <span className="exam-id">{index + 1}.</span>{" "}
                <span className="exam-title">{value.title}</span>
                {!isApplied && (
                  <span style={{ marginLeft: "10px", fontStyle: "italic" }}>
                    (Not Applied)
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  </div>
)} */}

 {showschedule && Array.isArray(schedule) && (
  <div className="exam-popup-overlay" style={{ position: "fixed" }}>
    <div className="exam-popup-box">
      <button
        className="exam-popup-close"
        onClick={() => setShowschedule(false)}
      >
        ×
      </button>

      <div style={{ maxHeight: "500px", overflowY: "auto" }}>
        {schedule.length > 0 ? (
          <ul className="exam-schedule-list">
            {[
              ...schedule.filter((value) => appalayids.includes(value.id)), // Applied first
              ...schedule.filter((value) => !appalayids.includes(value.id)) // Not applied after
            ].map((value, index) => {
              const isApplied = appalayids.includes(value.id);
              const isHovered = hoveredIndex === index;

              return (
                <li
                  key={value.id}
                  className="exam-schedule-item"
                  style={{
                    cursor: "pointer",
                    color: isApplied
                      ? isHovered ? "#333" : "black"
                      : isHovered ? "#b30000" : "red",
                    backgroundColor: isApplied
                      ? isHovered ? "#e0e0e0" : "#f0f0f0"
                      : isHovered ? "#ffcccc" : "#ffe5e5"
                  }}
                  onMouseEnter={() => setHoveredIndex(index)}
                  onMouseLeave={() => setHoveredIndex(null)}
                  onClick={() => {
                    if (!isApplied) {
                      handleNavigate();
                    } else {
                      setExamtypeid(value.id);
                      setEnterexam(true);
                    }
                  }}
                >
                  <span className="exam-id">{index + 1}.</span>{" "}
                  <span className="exam-title">{value.title}</span>
                  {!isApplied && (
                    <span style={{ marginLeft: "10px", fontStyle: "italic" }}>
                      (Not Applied)
                    </span>
                  )}
                </li>
              );
            })}
          </ul>
        ) : (
          <div style={{ textAlign: "center", padding: "20px", color: "gray" }}>
            📌 No exam schedule available
          </div>
        )}
      </div>
    </div>
  </div>
)}


{enterpraticeexam && (
  <div className="exam-popup-overlay" style={{position: 'fixed'}}>
    <div className="exam-popup-box">
      <button className="exam-popup-close" onClick={() => setEnterpraticeexam(false)}>×</button>

         <div className="exam-popup-content">
      <input
        type="text"
        placeholder="Student ID"
        className="exam-popup-input"
        value={studentid}
        onChange={(e) => setstudentid(e.target.value)}
      />
      <button className="exam-popup-button" onClick={handleSubmit_praticeexam}>
        Enter Exam
      </button>
    </div>
    </div>
  </div>
)}

{enterexam && (
  <div className="exam-popup-overlay" style={{position: 'fixed'}}>
    <div className="exam-popup-box">
      <button className="exam-popup-close" onClick={() => setEnterexam(false)}>×</button>

         <div className="exam-popup-content">
      <input
        type="text"
        placeholder="Student ID"
        className="exam-popup-input"
        value={studentid}
        onChange={(e) => setstudentid(e.target.value)}
      />
      <button className="exam-popup-button" onClick={handleSubmit}>
        Enter Exam
      </button>
    </div>
    </div>
  </div>
)}



            </div>
          </div>
        </div>
      </div>

      {customizersetting && <div className="customizer-container"></div>}

      <footer className="footer"  style={{
            marginLeft: isSidebarExpanded ? "250px" : "70px",
            transition: "margin-left 0.3s ease-out",
          }}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 footer-copyright">
              <p className="mb-0">
                Copyright 2022 ©  Maran Software Solutions.
              </p>
            </div>
            <div className="col-md-6">
              <p className="pull-right mb-0">
                Hand crafted & made with &nbsp;<i className="fa fa-heart"></i>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
  );
};

export default StudentProfile;
























